import { Box, Button, Text } from "@modernatx/ui-kit-react";
import React from "react";

interface PaginationProps {
  page: number;
  count: number;
  onPageChange: (page: number) => void;
  disabled?: boolean;
}

export const Pagination: React.FC<PaginationProps> = ({
  page,
  count,
  onPageChange,
  disabled = false
}) => {
  const isPrevDisabled = disabled || page <= 1;
  const isNextDisabled = disabled || page >= count;

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: 2
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          minHeight: "spacing-10"
        }}
      >
        <Button
          icon="caret-left"
          aria-label="Go to previous page"
          variant="subtle"
          onClick={() => !isPrevDisabled && onPageChange(page - 1)}
          role="tab"
          tabIndex={isPrevDisabled ? -1 : 0}
          disabled={isPrevDisabled}
          sx={{ alignSelf: "center" }}
        />
        <Box as="span" sx={{ minWidth: "spacing-6", textAlign: "center" }}>
          <Text sx={{ fontSize: "font-size-4" }}>
            {page} of {count}
          </Text>
        </Box>
        <Button
          icon="caret-right"
          aria-label="Go to next page"
          variant="subtle"
          onClick={() => !isNextDisabled && onPageChange(page + 1)}
          role="tab"
          tabIndex={isNextDisabled ? -1 : 0}
          disabled={isNextDisabled}
          sx={{ alignSelf: "center" }}
        />
      </Box>
    </Box>
  );
};
